<template>
  <div
    class="main"
    id="kanbanwrap"
    style="background:url(static/kanban.jpg)"
    :class="{ kanbanfull: $store.state.isFullScreen }"
  >
    <div id="kanbanwrapchild" :style="{ zoom: zoom + '%' }" v-if="resetKanban">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      zoom: 100,
      resetKanban: true,
    };
  },
  computed: {
    resetKanbanc() {
      return this.$store.state.isFullScreen;
    },
  },
  methods: {
    adaptation() {
      var w = document.body.clientWidth;
      var nw = 1920;
      this.zoom = (w * 100) / nw;
    },
  },
  mounted() {
    this.adaptation();
  },
  watch: {
    resetKanbanc(v) {
      this.resetKanban = false;
      setTimeout(() => {
        this.resetKanban = true;
      }, 100);
    },
  },
};
</script>
<style>
/*板块样式。因为这个是公用的样式 */
.block {
  background: #0b1852;
  color: #fff;
  margin-bottom: 20px;
  text-align: left;
  box-shadow: 2px 2px 20px #0c3a8a inset;
  outline: #294be4 solid 1px;
  outline-offset: -2px;
}
.block .chartWrap {
  width: 100%;
  height: 100%;
  padding: 20px 10px;
  text-align: center;
}
.block .title {
  color: #d6deff;
  text-align: left;
  padding: 10px 20px;
  position: relative;
  border-bottom: solid 1px #444;
  font-size: 16px;
  background: #00528e;
  background-image: linear-gradient(to bottom, #0a1d58, #00528e);
}
.block .title::before {
  content: "";
  height: 16px;
  width: 4px;
  background: #2697cc;
  position: absolute;
  left: 8px;
  top: 10px;
  box-shadow: -6px 0 14px #7eb9fc;
}
.block .title::after {
  content: "";
  height: 100%;
  width: 100px;
  background-image: linear-gradient(to right, #8396ec, #0f152f);
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}
.kanbanfull {
  top: 0;
  left: 0;
  z-index: 212;
  position: absolute;
  width: 100%;
  height: 100% !important;
  margin-top: 0 !important;
}
#kanbanwrap {
  background-size: 100% 100%;
  height: calc(100% - 50px);
  overflow: auto;
  padding: 0px 10px;
}

#kanbanwrapchild {
  position: relative;
  height: 100%;
}
#kanbanwrapchild .readMore {
  float: right;
  color: #6da7ff;
}
#kanbanwrapchild p,
#kanbanwrapchild div {
  color: #fff;
}
.kanbanDes label {
  color: #3182e6;
  margin-right: 6px;
}
.kanbanDes span {
  margin-right: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/kanbanWrap.vue